import { useApiClient } from '@@common';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { DataSchemaClient, SchemaSummaryModel } from '../../../api/api';

export default function useApiEntities(contextId: string): UseQueryResult<SchemaSummaryModel[], Error> {
	const client = useApiClient(DataSchemaClient);
	const metadata = useQuery({
		queryKey: ['schemas'],
		queryFn: () => client.getEntitiesForContext(contextId, undefined, true),
	});
	return metadata;
}
